import React, { useMemo } from 'react';
import { ExternalLink } from 'lucide-react';

const getPrimaryStatus = (result, isApproved) => {
  if (result.undoneAt) {
    return { text: '↩️ Undone', color: 'bg-orange-100 text-orange-800' };
  }

  if (result.applied) {
    return { text: '✅ Applied', color: 'bg-green-100 text-green-800' };
  }

  if (isApproved) {
    return { text: '✅ Approved', color: 'bg-green-100 text-green-800' };
  }

  if (result.status === 'failed') {
    return { text: '❌ Failed', color: 'bg-red-100 text-red-800' };
  }

  if (result.status === 'retry_pending') {
    return { text: '🔄 Retrying', color: 'bg-orange-100 text-orange-800' };
  }

  if (result.status === 'skipped') {
    return { text: '⏭️ Skipped', color: 'bg-yellow-100 text-yellow-800' };
  }

  if (result.status === 'pending') {
    return { text: '⏳ Pending', color: 'bg-gray-100 text-gray-800' };
  }

  return { text: '✅ Ready', color: 'bg-blue-100 text-blue-800' };
};

const PhotoStatusBadge = ({ result, isApproved }) => {
  const primaryStatus = useMemo(
    () => getPrimaryStatus(result, isApproved),
    [isApproved, result]
  );

  return (
    <div className="flex-shrink-0 flex items-center space-x-2">
      <span className={`px-3 py-1 rounded-full text-xs font-semibold ${primaryStatus.color}`}>
        {primaryStatus.text}
      </span>
      {result.pageUrl && (
        <a
          href={result.pageUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-blue-600 transition-colors"
          title="View photo"
        >
          <ExternalLink className="h-4 w-4" />
        </a>
      )}
    </div>
  );
};

export default PhotoStatusBadge;
